import { get, post, AbortController } from './../Config/config';

const controller = new AbortController();
const signal = controller.signal;

export const FollowUps = {
    get: (data) => get(`/follow-up-leads`, { params: data, }),
} 